// extracted by mini-css-extract-plugin
export var consent = "newsletter-banner-module--consent--7nhPL";
export var container = "newsletter-banner-module--container--BbOZA";
export var formContainer = "newsletter-banner-module--form-container--pTRLA";
export var formField = "newsletter-banner-module--form-field--r4rdY";
export var formInput = "newsletter-banner-module--form-input--EXiTl";
export var policy = "newsletter-banner-module--policy--ukvzP";
export var resetForm = "newsletter-banner-module--reset-form--JlC0L";
export var rodo = "newsletter-banner-module--rodo--pCq2W";
export var shorter = "newsletter-banner-module--shorter--TPtKX";
export var submitBtn = "newsletter-banner-module--submit-btn--6gDCl";
export var subtitle = "newsletter-banner-module--subtitle--irRKJ";
export var successMsg = "newsletter-banner-module--success-msg--m7-60";
export var thanksSubtitle = "newsletter-banner-module--thanks-subtitle--5xSnR";
export var title = "newsletter-banner-module--title--jQCF9";
export var withoutSubtitle = "newsletter-banner-module--without-subtitle--9yRS1";